export const environment = {
    production: false,
    loginUrl: 'https://login.oderp.in',
    // domain: "https://qa.odpay.in",
	domain:'https://staging.odpay.in',
    odPayDomain: "https://api.okiedokiepay.com",
    port: "/",
    api: "api",
	config: {
		profile: "https://staging.odpay.in",

		fee: "https://staging.odpay.in",
		accounting: "https://staging.odpay.in",

		admission: "https://staging.odpay.in",
		analytics: "https://staging.odpay.in",

		academic: "https://staging.odpay.in",
		coe: "https://staging.odpay.in",
		examination: "https://staging.odpay.in",
		schoolDiary: "https://staging.odpay.in",
		learningManagement: "https://staging.odpay.in",
		lessonPlan: "https://staging.odpay.in",

		attendance: "https://staging.odpay.in",
		hostel: "https://staging.odpay.in",
		transport: "https://staging.odpay.in",

		hrm: "https://staging.odpay.in",

		library: "https://staging.odpay.in",

		auth: "https://staging.odpay.in",
		communication: "https://staging.odpay.in",

		other: "https://staging.odpay.in",
		pdfExcelTemplate: "https://staging.odpay.in",
		reportFile: "https://staging.odpay.in",
		frontDesk: "https://staging.odpay.in",
		socialMedia: "https://staging.odpay.in",
		superAdmin: "https://staging.odpay.in",
	},
	s1config: {
		profile: "https://s1-api.odpay.in",

		fee: "https://s1-api.odpay.in",
		accounting: "https://s1-api.odpay.in",

		admission: "https://s1-api.odpay.in",
		analytics: "https://s1-api.odpay.in",

		academic: "https://s1-api.odpay.in",
		coe: "https://s1-api.odpay.in",
		examination: "https://s1-api.odpay.in",
		schoolDiary: "https://s1-api.odpay.in",
		learningManagement: "https://s1-api.odpay.in",
		lessonPlan: "https://s1-api.odpay.in",

		attendance: "https://s1-api.odpay.in",
		hostel: "https://s1-api.odpay.in",
		transport: "https://s1-api.odpay.in",

		hrm: "https://s1-api.odpay.in",

		library: "https://s1-api.odpay.in",

		auth: "https://s1-api.odpay.in",
		communication: "https://s1-api.odpay.in",

		other: "https://s1-api.odpay.in",
		pdfExcelTemplate: "https://s1-api.odpay.in",
		reportFile: "https://s1-api.odpay.in",
		frontDesk: "https://s1-api.odpay.in",
		socialMedia: "https://s1-api.odpay.in",
		superAdmin: "https://s1-api.odpay.in",
	},
	s2config: {
		profile: "https://s2-api.odpay.in",

		fee: "https://s2-api.odpay.in",
		accounting: "https://s2-api.odpay.in",

		admission: "https://s2-api.odpay.in",
		analytics: "https://s2-api.odpay.in",

		academic: "https://s2-api.odpay.in",
		coe: "https://s2-api.odpay.in",
		examination: "https://s2-api.odpay.in",
		schoolDiary: "https://s2-api.odpay.in",
		learningManagement: "https://s2-api.odpay.in",
		lessonPlan: "https://s2-api.odpay.in",

		attendance: "https://s2-api.odpay.in",
		hostel: "https://s2-api.odpay.in",
		transport: "https://s2-api.odpay.in",

		hrm: "https://s2-api.odpay.in",

		library: "https://s2-api.odpay.in",

		auth: "https://s2-api.odpay.in",
		communication: "https://s2-api.odpay.in",

		other: "https://s2-api.odpay.in",
		pdfExcelTemplate: "https://s2-api.odpay.in",
		reportFile: "https://s2-api.odpay.in",
		frontDesk: "https://s2-api.odpay.in",
		socialMedia: "https://s2-api.odpay.in",
		superAdmin: "https://s2-api.odpay.in",
	},
	c1config: {
		profile: "https://c1-api.odpay.in",

		fee: "https://c1-api.odpay.in",
		accounting: "https://c1-api.odpay.in",

		admission: "https://c1-api.odpay.in",
		analytics: "https://c1-api.odpay.in",

		academic: "https://c1-api.odpay.in",
		coe: "https://c1-api.odpay.in",
		examination: "https://c1-api.odpay.in",
		schoolDiary: "https://c1-api.odpay.in",
		learningManagement: "https://c1-api.odpay.in",
		lessonPlan: "https://c1-api.odpay.in",

		attendance: "https://c1-api.odpay.in",
		hostel: "https://c1-api.odpay.in",
		transport: "https://c1-api.odpay.in",

		hrm: "https://c1-api.odpay.in",

		library: "https://c1-api.odpay.in",

		auth: "https://c1-api.odpay.in",
		communication: "https://c1-api.odpay.in",

		other: "https://c1-api.odpay.in",
		pdfExcelTemplate: "https://c1-api.odpay.in",
		reportFile: "https://c1-api.odpay.in",
		frontDesk: "https://c1-api.odpay.in",
		socialMedia: "https://c1-api.odpay.in",
		superAdmin: "https://c1-api.odpay.in",
	},
	c2config: {
		profile: "https://c2-api.odpay.in",

		fee: "https://c2-api.odpay.in",
		accounting: "https://c2-api.odpay.in",

		admission: "https://c2-api.odpay.in",
		analytics: "https://c2-api.odpay.in",

		academic: "https://c2-api.odpay.in",
		coe: "https://c2-api.odpay.in",
		examination: "https://c2-api.odpay.in",
		schoolDiary: "https://c2-api.odpay.in",
		learningManagement: "https://c2-api.odpay.in",
		lessonPlan: "https://c2-api.odpay.in",

		attendance: "https://c2-api.odpay.in",
		hostel: "https://c2-api.odpay.in",
		transport: "https://c2-api.odpay.in",

		hrm: "https://c2-api.odpay.in",

		library: "https://c2-api.odpay.in",

		auth: "https://c2-api.odpay.in",
		communication: "https://c2-api.odpay.in",

		other: "https://c2-api.odpay.in",
		pdfExcelTemplate: "https://c2-api.odpay.in",
		reportFile: "https://c2-api.odpay.in",
		frontDesk: "https://c2-api.odpay.in",
		socialMedia: "https://c2-api.odpay.in",
		superAdmin: "https://c2-api.odpay.in",
	},
	cpconfig: {
		profile: "https://cp-api.odpay.in",

		fee: "https://cp-api.odpay.in",
		accounting: "https://cp-api.odpay.in",

		admission: "https://cp-api.odpay.in",
		analytics: "https://cp-api.odpay.in",

		academic: "https://cp-api.odpay.in",
		coe: "https://cp-api.odpay.in",
		examination: "https://cp-api.odpay.in",
		schoolDiary: "https://cp-api.odpay.in",
		learningManagement: "https://cp-api.odpay.in",
		lessonPlan: "https://cp-api.odpay.in",

		attendance: "https://cp-api.odpay.in",
		hostel: "https://cp-api.odpay.in",
		transport: "https://cp-api.odpay.in",

		hrm: "https://cp-api.odpay.in",

		library: "https://cp-api.odpay.in",

		auth: "https://cp-api.odpay.in",
		communication: "https://cp-api.odpay.in",

		other: "https://cp-api.odpay.in",
		pdfExcelTemplate: "https://cp-api.odpay.in",
		reportFile: "https://cp-api.odpay.in",
		frontDesk: "https://cp-api.odpay.in",
		socialMedia: "https://cp-api.odpay.in",
		superAdmin: "https://cp-api.odpay.in",
	},
		extraMarksConfig:{
		logout:"https://qa.extramarksforte.com/logout",
		adminDashboard:'https://qa.extramarksforte.com/faculty-admin-dashboard',
		facultyDashboard:'https://qa.extramarksforte.com/faculty-assessment-dashboard'
	},
    reactConfig:{
        expenseManagement:{
			host:'https://staging-finance.',
			path:'/expenseManagement/dashboard?hidden=true',
		},
		rollNoConfig:{
			host:'https://staging-academic.',
			path:'/academic/setup/assignRollNo?exact=true',
		},
		pocketMoneyDashboard:{
			host:'https://staging-finance.',
			path:'/pocket-money/dashboard?hidden=true',
		},
		pocketMoneyWalletTransaction:{
			host:' https://staging-finance.',
			path:'/pocket-money/wallet-transactions?hidden=true',
		},
		studentList:{
			host:'https://staging-student.',
			path:'/'
		},
		admission:{
			host:'https://staging-admission.',
			path:'/'
		},
		communication:{
			host:'https://staging-hub.',
			path:'/'
		},
		academics:{
			host:'https://staging-academic.',
			path:'/academic/setup'
		},
				schoolDiary:{
		assignment:{
			host:'https://staging-academic.',
			path:'/school-diary/assignment'
		},
		homework:{
			host:'https://staging-academic.',
			path:'/school-diary/homework'
		},
		circular:{
			host:'https://staging-academic.',
			path:'/school-diary/circular'
		},
		notice:{
			host:'https://staging-academic.',
			path:'/school-diary/notice'
		},
	},
	frontDesk:{
		gatePass:{
			host:'https://staging-hub.',
			path:'front-desk/gatepass'
		},
		visitor:{
			host:'https://staging-hub.',
			path:'front-desk/visitor'
		}
	},
	studentQueries:{
			host:'https://staging-student.',
			path:'/student/studentQueries?exact=true',
	},
	advanced:{
		seminar:{
			host:'https://staging-hub.',
			path:'/advanced/seminar',
		},
		event:{
			host:'https://staging-hub.',
			path:'/advanced/event',
		},
		chapterProceedings:{
			host:'https://staging-hub.',
		    path:'/advanced/chapterProceedings',
		},
		researchPublication:{
			host:'https://staging-hub.',
		    path:'/advanced/researchPublication',
		},
		resourcePerson:{
			host:'https://staging-hub.',
			path:'/advanced/resourcePerson',
		},
		incentiveReport:{
			host:'https://staging-hub.',
			path:'/advanced/incentiveReport',
		}
	},
	communicationReport:{
		sms:{
			host:'https://staging-hub.',
			path:'communication/sendSMS'
		},
		whatsapp:{
            host:'https://staging-hub.',
			path:'communication/webWhatsappMessage'
		},
		report:{
			host:'https://staging-hub.',
			path:'communication/report'
		}
	},
	gallery:{
			host:'https://staging-student.',
			path:'/gallery'
	},
	sharePoint:{
			host:'https://staging-hub.',
			path:'/cms/sharePoint'
	},
	lessonPlan:{
		lessonManagement:{
			host:'https://staging-academic.',
			path:'/lesson-plan/lesson-management'
		},
		subjectWiseReport:{
			host:'https://staging-academic.',
			path:'/lesson-plan/subject-wise-report'
		}
	},
	bulkOperation:{
		reportFile:{
			host:'https://staging-hub.',
			path:'/bulk-operation/reportFile',
		},
		excelUploadLogs:{
			host:'https://staging-hub.',
			path:'/bulk-operation/excelUploadLogs'
		},
		bulkRequestLogs:{
			host:'https://staging-hub.',
			path:'/bulk-operation/bulkRequestLogs'
		}
	},
		attendance:{
      	studentAttendance:{
			host:'https://staging-academic.',
			path:'/attendanceV3/studentAttendance'
		},
		markAttendanceStudentWise:{
			host:'https://staging-academic.',
			path:'/attendanceV3/markedAttendanceReportStudentWise'
		},
		markAttendanceTeacherWise:{
			host:'https://staging-academic.',
			path:'/attendanceV3/markedAttendanceTeacherWise'
		}				
		},
	transport:{
		assignTransport:{
			host:'https://staging-student.',
			path:'/transport/assignTransport'
		},
		transportSetup:{
			host:'https://staging-login.',
			path:'/transport/setup'
		}
	},
	feebackFromStudent:{
		allFacultyFeedbackReport:{
			host:'https://staging-student.',
			path:'/feedbackFromStudent/allFacultyFeedbackReport'
		},
		feedbackFromStudentMaster:{
			host:'https://staging-login.',
			path:'/schoolSetup/feedbackStudent'
		},
		gradeValueMaster:{
			host:'https://staging-login.',
			path:'/schoolSetup/gradeValueMaster'
		},
	},
	permissionGroup:{
		host:'https://staging-login.',
		path:'/schoolSetup/permissionGroups'
	},	
	cms:{
		host:'https://staging-hub.',
		path:'/cms?exact=true'
	},
	entityWebSiteSetup:{
		host:'https://staging-login.',
		path:'/schoolSetup/entityWebsiteCrud'
	},
	timeTable:{
		host:'https://staging-academic.',
		path:'/academic/setup/timeTable'
	},
	employeePortal:{
		profile:{
			host:'https://staging-hrm.',
			path:'/profilePortal/profile'
		},
		myLeave:{
			host:'https://staging-hrm.',
			path:'/profilePortal/applyLeaves'
		},
		attendanceCalendar:{
			host:'https://staging-hrm.',
			path:'/hrm/employeeAttendanceCalendar'
		},
		salarySlip:{
			host:'https://staging-hrm.',
			path:'/hrm/employeeSalarySummary'
		}	
	},
	library:{
		libraryBook:{
			host:'https://staging-hub.',
			path:'/library/libraryBook'
		},
		libraryMaster:{
			host:'https://staging-hub.',
			path:'/library/setup'
		},
		issueBook:{
			host:'https://staging-login.',
			path:'/library/issueBook'
		},
		stockVerify:{
			host:'https://staging-login.',
			path:'/library/stockVerify'
		},
	    issuedBook:{
			host:'https://staging-login.',
			path:'/library/issueRecords/libraryDetails'
		}
	},
	lectureScheduleMapper:{
		host:'https://staging-academic.',
		path:'/academic/setup/lectureSchedule'
	},
	employeeCalendarList:{
		host:'https://staging-academic.',
		path:'/academic/setup/employeeCalendarList'
	},
	hostel:{
		hosteReport:{
			host:'https://staging-student.',
			path:'/hostelAttendance/hostelReport'
		},
		hostelMaster:{
			host:'https://staging-login.',
			path:'/hostel/setup'
		},
		hosteAttendance:{
			host:'https://staging-login.',
			path:'/hostelAttendance'
		},
		messAttendance:{
			host:'https://staging-login.',
			path:'/messManagement/messAttendance'
		}
	}			
	}
}
